import Form from '@app/Preorder/Form'
import Modal from '@app/Preorder/Modal'
import Cart from '@app/Preorder/Cart'

export default function install(Vue) {
  Vue.component(Form.name, Form)
  Vue.component(Modal.name, Modal)
  Vue.component(Cart.name, Cart)
}
